<template>
  <div :class="b()">
    <div :class="b('title')" v-html="$t('app.mobile-only-stub.title')" />

    <component :is="qrComponent" :class="b('qr')" />

    <div :class="b('info')" v-html="$t('app.mobile-only-stub.info')" />
  </div>
</template>

<script src="./mobile-only-stub.scripts.js" />

<style module src="./mobile-only-stub.styles.scss" lang="scss" />
